import styled from 'styled-components'

export const Wrapper = styled.div`
  text-align: center;
  padding: 24px;
  button {
    background-color: #e7f3fe !important;
    border: none;
    border-radius: 8px;
    padding: 0 8px;
    font-weight: 700;
    color: #0085ff !important;
    svg {
      margin-right: 5px;
    }
    &:hover {
      opacity: 0.7;
    }
  }
`

export const IconWrapper = styled.div`
  width: 96px;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f0f0f0;
  margin: 0 auto;
  svg {
    background-color: white;
    border-radius: 8px;
    color: #757575;
    height: 56px;
    width: 56px !important;
    padding: 10px;
    box-sizing: inherit !important;
  }
`

export const Title = styled.div`
  color: #757575;
  padding: 16px 0 4px;
  font-size: 14px;
`
